import BaseModel from "@/core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";
import {store} from "@/plugins/vuex";

export default class Charge extends BaseModel {
  uuid = null;
  name = '';
  is_active = null;
  is_vat_inclusive = null;
  taxable = false;
  rate = null;
  amount = null;
  categories = [];
  category_uuids = [];
  tiers = [];
  extra_parameters_template = [];
  extra_parameters = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    name: 'required',
    rate: 'max_value:100|min_value:0',
  }

  attributeLabels = {
    name: i18n.t('Name'),
    is_active: i18n.t('Active'),
    taxable: i18n.t('Taxable'),
    is_vat_inclusive: store.state.global.isSalesTaxEnabled ? i18n.t('Tax Inclusive') : i18n.t('VAT Inclusive'),
    rate: i18n.t('Rate'),
    amount: i18n.t('Amount'),
    categories: i18n.t('Categories'),
    tiers: i18n.t('Charge Tiers'),
  }
}
